import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const SelectionExtendIcon = React.memo<IconProps>(
  ({ className = '', size = 16, width, height, color = 'currentColor', onClick }) => (
    <BaseIcon
      className={className}
      size={size}
      width={width}
      height={height}
      color={color}
      onClick={onClick}
      viewBox="0 0 16 16"
    >
      <rect x="2" y="2" width="8" height="8" fill={color} />
      <rect x="6" y="6" width="8" height="8" fill={color} />
    </BaseIcon>
  ),
);

SelectionExtendIcon.displayName = 'SelectionExtendIcon';
